import { useMemo } from "react";

import { SummaryText } from "@/app/app/_/views/RulesView/nodes/SummaryText";
import { mapServerSummaryParts } from "@/app/app/_/views/RulesView/utils/nodeSummary";
import { Typography } from "@/components/ui/typography";
import { formatToolName } from "./ToolCallCard.tools";
import type { ToolCallContent } from "./ToolCallCard.types";

/** Human-readable workflow step title for ``node_eval`` thread rows. */
export function ToolCallCardNodeSummary({ item }: { item: ToolCallContent }) {
  const parts = useMemo(
    () => mapServerSummaryParts(item.ruleNode?.summaryParts ?? null),
    [item.ruleNode?.summaryParts],
  );

  if (parts.length > 0) {
    return (
      <Typography
        component="div"
        level="body-md"
        className="flex-1 [line-height:1.35]"
      >
        <SummaryText parts={parts} />
      </Typography>
    );
  }

  if (item.text?.trim()) {
    return (
      <Typography level="body-md" className="flex-1">
        {item.text}
      </Typography>
    );
  }

  return (
    <Typography level="body-md" className="flex-1 flex items-center gap-1">
      {formatToolName(
        item.toolName ?? "unknown",
        item.children,
        item.toolInput,
        item.status,
      )}
    </Typography>
  );
}
